<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Direct Booking Site'"
      [canGoBack]="true"
      [customBack]="'direct-booking'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (config) {
      @if (!windowService.isDesktopRes && config.property_address) {
        <tidy-row>
          <tidy-text
            [helper]="config.property_address"
            [translate]="false" />
        </tidy-row>
      }

      <tidy-card>
        <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
          <tidy-text [header]="'Direct booking'" />
          <tidy-select
            class="status-select"
            [items]="statusItems"
            [form]="statusControl"
            (optionChange)="onStatusSelect($event)" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text [helper]="statusHint" />
        </tidy-row>

        <!-- A paused site has nothing to view: its URL serves the unavailable page. -->
        @if (config.is_published) {
          <tidy-row>
            <tidy-text [helper]="'Default URL'" />
          </tidy-row>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/svg/link-outline.svg'"
              class="body-size" />
            <tidy-text
              [body]="config.site_url"
              [translate]="false" />
            <tidy-image
              [src]="'assets/svg/copy-outline.svg'"
              class="body-size margin-left-5 clickable"
              (action)="copySiteUrl()" />
          </tidy-row>

          <tidy-card-button (action)="openView()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/open-outline.svg'"
                class="body-size" />
              <tidy-text [body]="'View Website'" />
            </tidy-row>
          </tidy-card-button>
        }

        <tidy-card-button (action)="goToListings()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/create-outline.svg'"
              class="body-size" />
            <tidy-text [body]="'Edit Details'" />
          </tidy-row>
          @if (isLoadingSummary) {
            <ion-skeleton-text
              animated="true"
              style="width: 50%; height: 14px; border-radius: 4px;" />
            <ion-skeleton-text
              animated="true"
              style="width: 85%; height: 14px; border-radius: 4px;" />
          } @else if (listingTitle || listingDescription) {
            @if (listingTitle) {
              <tidy-row>
                <tidy-text
                  [helper]="listingTitle"
                  [translate]="false" />
              </tidy-row>
            }
            @if (listingDescription) {
              <tidy-row>
                <tidy-text
                  [helper]="listingDescription"
                  [translate]="false" />
              </tidy-row>
            }
          } @else {
            <tidy-row>
              <tidy-text [helper]="'Add a title and description for your site.'" />
            </tidy-row>
          }
        </tidy-card-button>

        <tidy-card-button (action)="goToCustomDomain()">
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/link-outline.svg'"
              class="body-size" />
            <tidy-text [body]="'Custom Domain'" />
            <!-- Value + copy icon are grouped so the row's align-last-right
                 keeps them together on the right, and so the copy click can
                 be stopped before it reaches the card button's navigation. -->
            <span style="display: flex; align-items: center;">
              <tidy-text
                [body]="config.custom_domain || 'Not configured'"
                [translate]="false" />
              @if (config.custom_domain) {
                <tidy-image
                  [src]="'assets/svg/copy-outline.svg'"
                  class="body-size margin-left-5 clickable"
                  (click)="$event.stopPropagation()"
                  (action)="copyCustomDomain()" />
              }
            </span>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>

      <tidy-row [alignLastItemRight]="true" class="vertical-align-center extra-top-padding extra-bottom-padding">
        <tidy-text [header]="'Booking Links'" />
        @if (config.is_published) {
          <tidy-text
            [actionBody]="'Add Booking Link'"
            class="white-link link"
            (action)="goToCreateBookingLink()" />
        }
      </tidy-row>

      @if (!config.is_published) {
        <tidy-row class="extra-bottom-padding">
          <tidy-text [helper]="'List the site to add booking links.'" />
        </tidy-row>
      }

      @if (isLoadingLinks) {
        <tidy-card>
          <ion-skeleton-text
            animated="true"
            style="width: 60%; height: 16px; border-radius: 4px;" />
          <ion-skeleton-text
            animated="true"
            style="width: 35%; height: 14px; border-radius: 4px;" />
        </tidy-card>
      } @else if (!linkRows.length) {
        <tidy-row>
          <tidy-text [helper]="'No booking links'" />
        </tidy-row>
      } @else {
        @for (row of linkRows; track row.link.id) {
          <tidy-card>
            <tidy-card-button [hideArrow]="row.chip !== 'Booked'" (action)="openReservation(row.link)">
              <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
                <tidy-text
                  [body]="(row.link.check_in_date | date) + ' – ' + (row.link.check_out_date | date)"
                  [translate]="false" />
                <tidy-image
                  [src]="'assets/svg/copy-outline.svg'"
                  class="body-size margin-left-5 clickable"
                  (click)="$event.stopPropagation()"
                  (action)="copyLink(row.link)" />
              </tidy-row>
              <tidy-row class="vertical-align-center">
                <span
                  style="display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:6px;"
                  [ngStyle]="{ 'background-color': row.dotColor }"></span>
                <tidy-text [helper]="row.chip" />
                <tidy-text
                  [helper]="'· ' + (row.amountCents / 100 | currency)"
                  [translate]="false" />
              </tidy-row>
              @if (row.chip === 'Booked' && row.link.guest?.name) {
                <tidy-row>
                  <tidy-text
                    [helper]="row.link.guest.name"
                    [translate]="false" />
                </tidy-row>
              }
              @if (row.chip === 'Active') {
                <tidy-row>
                  <tidy-text
                    [actionBody]="'Revoke'"
                    class="link red"
                    (click)="$event.stopPropagation()"
                    (action)="revoke(row.link)" />
                </tidy-row>
              }
            </tidy-card-button>
          </tidy-card>
        }
      }
    }

    @if (!config) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No site configuration found.'" />
        </tidy-row>
      </tidy-alert>
    }
  </tidy-wrapper>
</ng-template>

<!-- Desktop mounts this page inside the right-side-panel dialog, which already
     provides its own scrollable container and its own title/back chrome. Going
     through app-scroll-wrapper there would make the page an .ion-page
     (position: absolute; inset: 0) anchored to the modal, so it would ignore
     the subtitle band above it and get clipped by it. Mobile is a standalone
     route and still needs the scroll surface (mirrors the day-detail pattern). -->
@if (windowService.isDesktopRes) {
  <ng-container *ngTemplateOutlet="content" />
} @else {
  <app-scroll-wrapper [templateContent]="content" />
}
